import React, { useContext } from 'react'
import { AirconBookingDateTime } from '../index/service-category/aircon-service/AirconBookingDateTime';
import { RequestContext } from '../../context/RequestContext';
import { DomesticServiceDateTime } from '../index/service-category/domestic-service/DomesticServiceDateTime';
import { HandymanDateTime } from '../index/service-category/handyman/HandymanDateTime';
import { TrainerBookingDateTime } from '@/index/service-category/personal-trainer/TrainerBookingDateTime';

export const ServiceDateTime = (props) => {
    const goBack = props.goBack
    const goToSection4 = props.goToSection4
    const countryName = props.countryName
    const countryCurrCd = props.countryCurrCd
    
    const { requestType } = useContext(RequestContext)

  return (
    <>
        <>
            {/* <div className="text-center text-orange-600 text-xl px-2">
                Brief description of your request
            </div> */}
            {requestType === "Aircon Services" &&
                <AirconBookingDateTime 
                    goBack={goBack}
                    goToSection4={goToSection4}
                    countryName={countryName}
                    countryCurrCd={countryCurrCd}
                />
            }
            {requestType === "Domestic Services" &&
                <DomesticServiceDateTime 
                    goBack={goBack}
                    goToSection4={goToSection4}
                    countryName={countryName}
                    countryCurrCd={countryCurrCd}
                />
            }
            {requestType === "Handyman Services" &&
                <HandymanDateTime 
                    goBack={goBack}
                    goToSection4={goToSection4}
                    countryName={countryName}
                    countryCurrCd={countryCurrCd}
                />
            }
            {requestType === "Fitness Trainer" &&
                <TrainerBookingDateTime 
                    goBack={goBack}
                    goToSection4={goToSection4}
                    countryName={countryName}
                    countryCurrCd={countryCurrCd}
                />
            }
        </>
    </>
  )
}
